import { render, staticRenderFns } from "./list.vue?vue&type=template&id=377f4e71&scoped=true"
import script from "./list.vue?vue&type=script&lang=ts"
export * from "./list.vue?vue&type=script&lang=ts"
import style0 from "./list.vue?vue&type=style&index=0&id=377f4e71&prod&lang=scss"
import style1 from "./list.vue?vue&type=style&index=1&id=377f4e71&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377f4e71",
  null
  
)

export default component.exports